module.exports = __webpack_public_path__ + "assets/img/e3.c622d554.jpg";